import { render, staticRenderFns } from "./OrderDiscount-gt3.vue?vue&type=template&id=5c233b9a&scoped=true"
import script from "./OrderDiscount-gt3.vue?vue&type=script&lang=js"
export * from "./OrderDiscount-gt3.vue?vue&type=script&lang=js"
import style0 from "./OrderDiscount-gt3.vue?vue&type=style&index=0&id=5c233b9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c233b9a",
  null
  
)

export default component.exports